export default "__VITE_ASSET__bj92b9kz__"